import { useApiRequests } from 'hooks/useApiRequests';
import { Typography } from '@mui/material';
import classnames from 'classnames';
import { getFileIconByType, replaceURLsInString } from 'utils';
import { ChatUiMessage } from 'types/chat';

import styles from './ChatMessage.module.scss';

type ChatMessageProps = {
  message: ChatUiMessage;
  isMy: boolean;
  isGroup: boolean;
};

export function ChatMessage({ message, isMy, isGroup }: ChatMessageProps): JSX.Element {
  const { downloadSharedDocument } = useApiRequests();

  // 📎 Check if it's a shared document file from DocumentsPickerDialog
  const isSharedFileString = message.type === 'text' && message.body?.startsWith('[📎 Shared File]');
  const [sharedName, sharedSize, blobPath] =
    isSharedFileString && message.body?.includes('|') ? message.body.replace('[📎 Shared File] ', '').split('|') : [];

  const handleSharedFileClick = async () => {
    if (!sharedName || !blobPath) return;

    try {
      console.log('📥 Download initiated for shared file:', {
        sharedName,
        blobPath,
      });

      // Use shared download endpoint for chat file links.
      await downloadSharedDocument(blobPath, sharedName);

      console.log(`✅ Download success, saving as: ${sharedName}`);
    } catch (err) {
      console.error('❌ Failed to download shared document:', err);
    }
  };

  if (isSharedFileString && sharedName && sharedSize && blobPath) {
    return (
      <div
        className={classnames(
          styles.message,
          styles.fileMessage,
          isMy ? styles.messageMy : '',
          isGroup ? styles.messageGroup : '',
          isGroup && isMy ? styles.messageMyGroup : '',
        )}
        onClick={handleSharedFileClick}
        style={{ cursor: 'pointer' }}
      >
        <div className={styles.fileIcon}>{getFileIconByType(sharedName)}</div>
        <div>
          <Typography component='p' variant='body1'>
            {sharedName}
          </Typography>
          <Typography component='p' variant='body6' sx={{ color: 'var(--app-text-muted)' }}>
            {sharedSize}
          </Typography>
        </div>
      </div>
    );
  }

  return (
    <div
      className={classnames(
        styles.message,
        isMy ? styles.messageMy : '',
        isGroup ? styles.messageGroup : '',
        isGroup && isMy ? styles.messageMyGroup : '',
      )}
    >
      <Typography component='p' variant='body5'>
        {replaceURLsInString(message.body ?? '')}
      </Typography>
    </div>
  );
}
